import { useLocationStore } from '@global-store/stores/location'

export const localizeUrl = (
  url: string,
  searchParams?: Record<string, string | number | boolean | undefined>
) => {
  const locationStore = useLocationStore()

  const localizedUrl = url.startsWith(`/${locationStore.currentUrlPrefix}`)
    ? url
    : `/${locationStore.currentUrlPrefix}${url}`

  if (!searchParams) {
    return localizedUrl
  }

  const urlSearchParams = new URLSearchParams(
    Object.entries(searchParams).reduce((newSearchParams, [key, value]) => {
      // Remove undefined values
      if (value === null || typeof value === 'undefined') {
        return newSearchParams
      }

      return {
        ...newSearchParams,
        // Convert number and boolean to string
        [key]: String(value),
      }
    }, {})
  )

  return `${localizedUrl}?${urlSearchParams.toString()}`
}
